import { inject, Injectable } from '@angular/core';
import { HttpClientService } from '../httpClient/http-client.service';
import { BulkMailerPayload } from '../../interfaces/bulk-mailer.interface';
import { Observable } from 'rxjs';
import { BULK_MAILER_API } from '../../constants/bulk-mailer-api-const';
import { appMasterApi } from '../../constants/app-master-const';
import { agentsApi } from '../../constants/agent-api';
import { DEFAULT_PREVIEW_CONFIG, EmailPreviewData, PreviewWindowConfig } from '../../interfaces/email-preview.interface';
import { Router } from '@angular/router';
import { LocalStorageService } from '../localStorage/local-storage.service';
@Injectable({
  providedIn: 'root'
})
export class BulkMailerService {
  private readonly httpClientService = inject(HttpClientService);
  private _router = inject(Router);
  private _localStorageService = inject(LocalStorageService)
  currentUserData: any;

  constructor() {
    this.loadCurrentUser()
  }

  async loadCurrentUser() {
    try {
      const storageKey = 'currentUser';
      const res = await this._localStorageService.getKeyIndexedDbKey(storageKey);
      const newRes = res?.roles?.[0]?.tenant;
      this.currentUserData = newRes.join(',');

    } catch (err) {
      console.error('Error:', err);
    }
  }


  getCampaigns(
    skip: number,
    limit: number,
    status?: string,
    tenantId?: string,
    fromDate?: string,
    toDate?: string
  ): Observable<any> {
    const queryParams: Record<string, string> = {
      displayType: 'readAll',
      sortDataOption: 'id',
      sortDataOrder: '-1',
      skip: skip.toString(),
      limit: limit.toString(),
    };

    const optionalParams = {
      status,
      tenantId,
      fromDate,
      toDate
    };

    // Add optional params only if they have a value
    for (const [key, value] of Object.entries(optionalParams)) {
      if (value) {
        queryParams[key] = value;
      }
    }

    const queryString = new URLSearchParams(queryParams).toString();
    const url = `${BULK_MAILER_API.getCampaigns}?${queryString}`;
    return this.httpClientService.get(url);
  }

  deleteCampaign(id: any): Observable<any> {
    return this.httpClientService.delete(`${BULK_MAILER_API.deleteCampaign}${id}`);
  }

  getSegments(
    skip: number,
    limit: number,
    name?: string,
    status?: string,
    tenantId?: string,
    module?: string
  ): Observable<any> {
    const queryParams: Record<string, string> = {
      displayType: 'readAll',
      sortDataOption: 'id',
      sortDataOrder: '-1',
      skip: skip.toString(),
      limit: limit.toString(),
    };

    const optionalParams = {
      name,
      status,
      tenantId,
      module
    };

    // Add optional params only if they have a value
    for (const [key, value] of Object.entries(optionalParams)) {
      if (value) {
        queryParams[key] = value;
      }
    }

    const queryString = new URLSearchParams(queryParams).toString();
    const url = `${BULK_MAILER_API.getSegments}?${queryString}`;
    return this.httpClientService.get(url);
  }

  createCampaign(payload: any): Observable<any> {
    return this.httpClientService.post(`${BULK_MAILER_API.createCampaign}`, payload, false, false, true)
  }
  createTestMail(payload: any): Observable<any> {
    return this.httpClientService.post(`${BULK_MAILER_API.testMail}`, payload, false, false, true)
  }

  updateCampaign(id: any, payload: any): Observable<any> {
    return this.httpClientService.put(`${BULK_MAILER_API.updateCampaign}${id}`, payload)
  }

  createSegmanet(payload: any): Observable<any> {
    return this.httpClientService.post(`${BULK_MAILER_API.createSegmanet}`, payload);
  }

  updateSegment(id: any, payload: any): Observable<any> {
    return this.httpClientService.put(`${BULK_MAILER_API.updateSegment}${id}`, payload)
  }

  getAgents(
    skip: number,
    limit: number,
    tenantId?: string,
    country?: string,
    state?: string,
    // company?: string,
    agentBadge?: string,
    primaryStatus?: string,
    secondaryStatus?: string,
    universityCountry?: string,
    university?: string,
    intake?: string,
    course?: string,
    addedDate?: string,
    courseType?: string,
    status?: string
  ): Observable<any> {
    const queryParams: Record<string, string> = {
      displayType: 'readAll',
      sortDataOption: 'createdAt',
      sortDataOrder: '-1',
      skip: skip.toString(),
      limit: limit.toString(),
    };

    const optionalParams = {
      tenantId,
      country,
      state,
      // company
      agentBadge,
      primaryStatus,
      secondaryStatus,
      universityCountry,
      university,
      intake,
      course,
      addedDate,
      courseType,
      status
    };

    // Add optional params only if they have a value
    for (const [key, value] of Object.entries(optionalParams)) {
      if (value) {
        queryParams[key] = value;
      }
    }

    const queryString = new URLSearchParams(queryParams).toString();
    const url = `${agentsApi.agentsCURD}?${queryString}`;
    return this.httpClientService.get(url);
  }

  getSegmentDetailsById(id: string): Observable<any> {
    return this.httpClientService.get(`${BULK_MAILER_API.getSegmentDetailsById}${id}`);
  }

  getSegmentContacts(params: {
    skip: number,
    limit: number,
    audienceId?: string,
    countryName?: any,
    companyName?: string,
    tag?: string,
    email?: string
  }): Observable<any> {
    const queryParams: Record<string, string> = {
      skip: params.skip.toString(),
      limit: params.limit.toString(),
      tenantId: this.currentUserData
    };

    // Add optional params only if they have a value
    const optionalParams = {
      audienceId: params.audienceId,
      countryName: Array.isArray(params.countryName) ? params.countryName.join(',') : params.countryName,
      companyName: params.companyName,
      tag: params.tag,
      email: params.email
    };

    for (const [key, value] of Object.entries(optionalParams)) {
      if (value) {
        queryParams[key] = value;
      }
    }

    const queryString = new URLSearchParams(queryParams).toString();
    const url = `${BULK_MAILER_API.getSegmentContacts}?${queryString}`;
    return this.httpClientService.get(url);
  }

  getActivityLogs(
    skip: number,
    limit: number,
    id?: string,
    status?: string,
    email?: string,
    name?: string,
  ): Observable<any> {
    const queryParams: Record<string, string> = {
      displayType: 'readAll',
      sortDataOption: 'createdAt',
      sortDataOrder: '-1',
      skip: skip.toString(),
      limit: limit.toString(),
    };

    if (status) queryParams['status'] = status;
    if (email) queryParams['email'] = email;
    if (name) queryParams['name'] = name;

    const queryString = new URLSearchParams(queryParams).toString();
    const url = `${BULK_MAILER_API.getActivityLogs.replace('id', id!)}?${queryString}`;
    return this.httpClientService.get(url);
  }

  getCampaignDetails(
    id: string
  ): Observable<any> {

    const url = `${BULK_MAILER_API.getCampaignDetails}${id}`;
    return this.httpClientService.get(url);
  }

  getEmailTemplates(
    skip: number,
    limit: number,
    tenantId: any,
    name?: string
  ): Observable<any> {
    let quary
    quary = `?skip=${skip}&limit=${limit}`
    if (tenantId) {
      quary += `&tenantId=${decodeURIComponent(tenantId)}`
    }
    if (name) {
      quary += `&name=${name}`
    }
    const url = `${BULK_MAILER_API.getEmailTemplates}${quary}`;
    return this.httpClientService.get(url);
  }

  createTemplate(payload: any): Observable<any> {
    return this.httpClientService.post(`${BULK_MAILER_API.createEmailTemplates}`, payload);
  }

  deleteTemplate(id: any): Observable<any> {
    return this.httpClientService.delete(`${BULK_MAILER_API.deleteTemplate}${id}`);
  }

  updateTemplate(id: any, payload: any): Observable<any> {
    return this.httpClientService.put(`${BULK_MAILER_API.updateTemplate}${id}`, payload);
  }

  importContacts(id: any, payload: any) {
    const formData = new FormData();

    Object.keys(payload).forEach((key) => {
      if (payload[key] !== null && payload[key] !== undefined) {
        formData.append(key, payload[key]);
      }
    });

    return this.httpClientService.upload(
      `${BULK_MAILER_API.importContacts.replace('id', id!)}`,
      formData
    );
  }

  downloadContactFormat(): Observable<any> {
    const url = `${BULK_MAILER_API.downloadContactFormat}`;
    return this.httpClientService.getBlob(url, {
      responseType: 'blob'
    });
  }

  exportContacts(payload: any): Observable<any> {
    const url = `${BULK_MAILER_API.exportContacts}`;
    // return this.httpClientService.post(url, payload);
    // return this.httpClientService.getBlob(url);
    return this.httpClientService.getContactsBlob(url, payload);
  }

  getCourses(
    skip: number,
    limit: number,
    courseType?: any,
    universityCountry?: any,
    universityId?: any
  ): Observable<any> {
    const queryParams: Record<string, string> = {
      displayType: 'readAll',
      sortDataOption: 'createdAt',
      sortDataOrder: '-1',
      skip: skip.toString(),
      limit: limit.toString(),
    };

    const optionalParams = {
      courseType,
      universityCountry,
      universityId
    };

    // Add optional params only if they have a value
    for (const [key, value] of Object.entries(optionalParams)) {
      if (value) {
        queryParams[key] = value;
      }
    }

    const queryString = new URLSearchParams(queryParams).toString();
    const url = `${BULK_MAILER_API.getCourses}?${queryString}`;
    return this.httpClientService.get(url);
  }

  importMedia(payload: any) {
    const formData = new FormData();

    Object.keys(payload).forEach((key) => {
      if (payload[key] !== null && payload[key] !== undefined) {
        formData.append(key, payload[key]);
      }
    });

    return this.httpClientService.upload(
      `${BULK_MAILER_API.importMediaFiles}`,
      formData
    );
  }

  getMediaFiles(
    skip: number,
    limit: number
  ): Observable<any> {

    const url = `${BULK_MAILER_API.getMediaFiles}`;
    return this.httpClientService.get(url);
  }

  deleteMediaFiles(id: any): Observable<any> {
    return this.httpClientService.delete(`${BULK_MAILER_API.deleteMediaFiles}${id}`);
  }

  updateMediaFiles(id: any, payload: any): Observable<any> {
    return this.httpClientService.put(`${BULK_MAILER_API.updateMediaFiles}${id}`, payload);
  }

  getMailSender(
    skip: number,
    limit: number
  ): Observable<any> {
    const queryParams: Record<string, string> = {
      displayType: 'readAll',
      sortDataOption: 'createdAt',
      sortDataOrder: '-1',
      skip: skip.toString(),
      limit: limit.toString(),
      tenantId: this.currentUserData
    };

    const queryString = new URLSearchParams(queryParams).toString();

    const url = `${BULK_MAILER_API.getMailSender}?${queryString}`;
    return this.httpClientService.get(url);
  }

  createMailSender(payload: any): Observable<any> {
    return this.httpClientService.post(`${BULK_MAILER_API.createMailSender}`, payload);
  }

  deleteMailSender(id: any): Observable<any> {
    return this.httpClientService.delete(`${BULK_MAILER_API.deleteMailSender}${id}`);
  }

  updateMailSender(id: any, payload: any): Observable<any> {
    return this.httpClientService.put(`${BULK_MAILER_API.updateMailSender}${id}`, payload);
  }

  deleteSegments(id: any): Observable<any> {
    return this.httpClientService.delete(`${BULK_MAILER_API.deleteSegments}${id}`);
  }

  deleteSegmentsContacts(payload: any): Observable<any> {
    return this.httpClientService.post(`${BULK_MAILER_API.deleteSegmentsContacts}`, payload);
  }

  openPreview(
    previewData: EmailPreviewData,
    config?: Partial<PreviewWindowConfig>
  ): Window | null {
    // Merge with default config
    const windowConfig = { ...DEFAULT_PREVIEW_CONFIG, ...config };

    // Store data for child window to access
    (window as any).emailPreviewData = previewData;

    // Build the preview URL
    const urlTree = this._router.createUrlTree(['/campaigns/preview']);
    const path = this._router.serializeUrl(urlTree);
    const fullUrl = `${window.location.origin}${path}`;

    // Build window features string
    const windowFeatures = this.buildWindowFeatures(windowConfig);

    // Open the window
    const previewWindow = window.open(
      fullUrl,
      windowConfig.windowName || 'EmailPreview',
      windowFeatures
    );

    if (previewWindow) {
      previewWindow.focus();
      return previewWindow;
    } else {
      console.warn('[EmailPreviewService] Pop-up blocked!');
      this.showPopupBlockedAlert();
      return null;
    }
  }

  private buildWindowFeatures(config: PreviewWindowConfig): string {
    if (config.features) {
      return config.features;
    }

    return [
      `width=${config.width || 1000}`,
      `height=${config.height || 800}`,
      'menubar=no',
      'toolbar=no',
      'location=no',
      'status=no',
      'scrollbars=yes',
      'resizable=yes'
    ].join(',');
  }

  private showPopupBlockedAlert(): void {
    alert('Please allow pop-ups for this site to view the email preview.');
  }

  getUnsubscribeMailLog(payload: any): Observable<any> {
    return this.httpClientService.post(`${BULK_MAILER_API.getUnsubscribeMailLog}`, payload);
  }


  getTemplateVariable(): Observable<any> {
    const url = `${BULK_MAILER_API.getTemplateVariable}`;
    return this.httpClientService.get(url);
  }

  getTag(
    skip: number,
    limit: number,
    tenantId?: any,
    searchTerm: string = ''
  ): Observable<any> {
    const queryParams: Record<string, string> = {
      displayType: 'readAll',
      sortDataOption: 'createdAt',
      sortDataOrder: '-1',
      skip: skip.toString(),
      limit: limit.toString(),
      tenantId: tenantId
    };

    const optionalParams = {
      searchTerm
    };

    // Add optional params only if they have a value
    for (const [key, value] of Object.entries(optionalParams)) {
      if (value) {
        queryParams[key] = value;
      }
    }

    const queryString = new URLSearchParams(queryParams).toString();

    const url = `${BULK_MAILER_API.getTag}?${queryString}`;
    return this.httpClientService.get(url);
  }

  createTag(payload: any): Observable<any> {
    return this.httpClientService.post(`${BULK_MAILER_API.createTag}`, payload);
  }

  deleteTag(id: any): Observable<any> {
    return this.httpClientService.delete(`${BULK_MAILER_API.deleteTag}${id}`);
  }

  updateTag(id: any, payload: any): Observable<any> {
    return this.httpClientService.put(`${BULK_MAILER_API.updateTag}${id}`, payload);
  }

  createUpdateContactSegment(query: any, payload: any): Observable<any> {
    return this.httpClientService.post(`${BULK_MAILER_API.createUpdateContactSegment}${query}`, payload);
  }
  getUser(
    skip: number,
    limit: number,
    roleId?: any
  ): Observable<any> {
    const queryParams: Record<string, string> = {
      status: 'true',
      skip: skip.toString(),
      limit: limit.toString(),
    };

    const optionalParams = {
      roleId
    };

    // Add optional params only if they have a value
    for (const [key, value] of Object.entries(optionalParams)) {
      if (value) {
        queryParams[key] = value;
      }
    }
    const queryString = new URLSearchParams(queryParams).toString();
    const url = `${agentsApi.usersApi}?${queryString}`;
    return this.httpClientService.get(url);
  }

  getRecipientsWithTagsList(
    skip: number,
    limit: number,
    audienceName?: string,
    storeId?: string,
    optionIds?: string,
  ): Observable<any> {
    const queryParams: Record<string, string> = {
      displayType: 'readAll',
      sortDataOption: 'id',
      sortDataOrder: '-1',
      skip: skip.toString(),
      limit: limit.toString(),
    };

    const optionalParams = {
      audienceName, storeId, optionIds
    };

    // Add optional params only if they have a value
    for (const [key, value] of Object.entries(optionalParams)) {
      if (value) {
        queryParams[key] = value;
      }
    }

    const queryString = new URLSearchParams(queryParams).toString();
    const url = `${BULK_MAILER_API.getRecipientsWithTagsList}?${queryString}`;
    return this.httpClientService.get(url);
  }


  // Agent Report Campaigns
  getAgentReportCampaigns({
    skip = 0,
    limit = 50,
  }: {
    skip: number,
    limit: number,
  }) {
    let query = `?skip=${skip}&limit=${limit}`;
    return this.httpClientService.get(`${BULK_MAILER_API.getAgentReportCampaigns}${query}`);
  }


  getAgentReportCampaignDetails(id: string) {
    let query = `?campaignId=${id}`;
    return this.httpClientService.get(`${BULK_MAILER_API.getAgentReportCampaignDetails}${query}`);
  }

  getAgentReportActivityLogs({
    skip = 0,
    limit = 50,
    campaignId = ''
  }: {
    skip: number,
    limit: number,
    campaignId: string
  }) {
    let query = `?skip=${skip}&limit=${limit}&campaignId=${campaignId}`;
    return this.httpClientService.get(`${BULK_MAILER_API.getAgentReportActivityLogs}${query}`);
  }

  openInternalPreview(
    previewData: EmailPreviewData,
    config?: Partial<PreviewWindowConfig>
  ): Window | null {
    // Merge with default config
    const windowConfig = { ...DEFAULT_PREVIEW_CONFIG, ...config };

    // Store only the email body for internal preview
    (window as any).emailPreviewData = {
      emailBody: previewData?.emailBody || '',
      previewOnlyBody: true
    };

    // Build the preview URL
    const urlTree = this._router.createUrlTree(['/campaigns/preview']);
    const path = this._router.serializeUrl(urlTree);
    const fullUrl = `${window.location.origin}${path}`;

    // Build window features string
    const windowFeatures = this.buildWindowFeatures(windowConfig);

    // Open the window
    const previewWindow = window.open(
      fullUrl,
      windowConfig.windowName || 'EmailPreview',
      windowFeatures
    );

    if (previewWindow) {
      previewWindow.focus();
      return previewWindow;
    } else {
      console.warn('[EmailPreviewService] Pop-up blocked!');
      this.showPopupBlockedAlert();
      return null;
    }
  }

  exportActivityLogs(
    id: string,
    status: string = '',
    email: string = '',
    name: string = '',
  ): Observable<any> {
    const queryParams: Record<string, string> = {
      displayType: 'readAll',
      sortDataOption: 'createdAt',
      sortDataOrder: '-1',
    };

    if (status) queryParams['status'] = status;
    if (email) queryParams['recipientEmail'] = email;
    if (name) queryParams['recipientName'] = name;

    const queryString = new URLSearchParams(queryParams).toString();
    const url = `${BULK_MAILER_API.getActivityLogs.replace('id', id)}/export?${queryString}`;
    return this.httpClientService.postBlob(url, {});
  }

}
